import TransactionService from '../services/transaction.service';

const user = JSON.parse(localStorage.getItem('user'));
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const transaction = {
  namespaced: true,
  state: initialState,
  actions: {
    sendMoney({ commit }, data) {
      return TransactionService.sendMoney(data).then(
        data => {
          commit('sendSuccess', data);
          return Promise.resolve(data);
        },
        error => {
          commit('sendFailure');
          return Promise.reject(error);
        }
      );
    }
  }
};
